import React from 'react'

function Projects() {
  return (
    <h1>Contact</h1>
  )
}

export default Projects